import React from "react";
import { ChangelogList, StyledCheckCircleIcon, StyledTypography } from "./styles";
import { useTranslation } from "../../context/TranslationContext";
import { renderInlineEmphasis } from "../../utils/renderInlineEmphasis";

const ChangelogItem = ({ item }) => {
	const { language } = useTranslation();

	const title = item?.title?.[language] || item?.title?.en || "";

	const description = item?.description?.[language] || item?.description?.en || "";

	const rawBody = item?.body?.[language] || item?.body?.en || null;

	const bodyLines = Array.isArray(rawBody)
		? rawBody.filter((line) => typeof line === "string" && line.trim().length > 0)
		: [];

	const layoutHint = item?.ui?.layout; // "inline" | "block" | undefined
	const hasBody = bodyLines.length > 0;
	const isBlockLayout = hasBody || layoutHint === "block";

	// Nothing useful to render
	if (!title && !description && !hasBody) return null;

	return (
		<ChangelogList>
			<StyledCheckCircleIcon />

			{isBlockLayout ? (
				<div>
					{/* Title on its own line */}
					<StyledTypography variant="body2">
						<strong>{title}</strong>
					</StyledTypography>

					{/* Prefer body if present, otherwise fall back to description as a paragraph */}
					{hasBody
						? bodyLines.map((line, index) => (
								<StyledTypography
									key={index}
									variant="body2"
									sx={{ marginTop: index === 0 ? 0.5 : 0.25 }}
								>
									{renderInlineEmphasis(line)}
								</StyledTypography>
						  ))
						: description && (
								<StyledTypography variant="body2" sx={{ marginTop: 0.5 }}>
									{renderInlineEmphasis(description)}
								</StyledTypography>
						  )}
				</div>
			) : (
				// Inline layout: keep exactly the old behavior
				<StyledTypography variant="body2">
					<strong>{title}</strong>
					{description ? ` – ${description}` : null}
				</StyledTypography>
			)}
		</ChangelogList>
	);
};

export default ChangelogItem;
